module.exports = __webpack_public_path__ + "img/128x128_star_unscannable.1f4aec8d.svg";